/* 🤖 this file was generated by svg-to-ts */
export const matIcon3P: {
  name: '3-p';
  data: string;
} = {
  name: '3-p',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 2H4.01c-1.1 0-2 .9-2 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12zm-8-6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm4 3.43c0-.81-.48-1.53-1.22-1.85a6.95 6.95 0 0 0-5.56 0A2.01 2.01 0 0 0 8 13.43V14h8v-.57z"/></svg>`
};
